export default __webpack_public_path__ + "static/media/property_201.8ee792aa.png";